<template>
    <v-container pa-0 fluid fill-height>
        <v-layout row wrap align-center justify-center>
            <v-flex xs12 md9 lg6 >
                <h1 class="primary white--text text-xs-center py-4 display-1">
                    Welcome! ようこそ！ 환영!
                </h1>
                <v-container fluid>
                    <v-layout>
                        <v-flex sm4>
                            <h4 class="mb-4 text-xs-center title font-weight-light">
                                Sign in with account
                            </h4>
                            <v-form >
                                <v-text-field
                                    v-model="email"
                                    outline
                                    prepend-icon="alternate_email"
                                    label="Email"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="password"
                                    outline
                                    prepend-icon="lock_open"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    @click:append="showPassword = !showPassword"
                                    :type="showPassword ? 'text' : 'password'"
                                    label="Password"
                                    required
                                ></v-text-field>
                                <v-btn
                                    color="primary"
                                    :disabled="!email || !password"
                                    large
                                    @click="submitSignin"
                                >Sign in</v-btn>
                                <h4 v-if="error.length > 0"
                                    class="my-4 text-xs-center title font-weight-light red--text"
                                >{{ error }}</h4>
                            </v-form>
                        </v-flex>
                        <v-flex sm4 class="px-4">
                            <h4 class="mb-4 text-xs-center title font-weight-light">
                                Sign in with social network
                            </h4>
                            <v-img src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"></v-img>
                            <v-img src="https://github.githubassets.com/images/modules/logos_page/GitHub-Logo.png"></v-img>
                        </v-flex>
                        <v-flex sm4>
                            <h4 class="mb-4 text-xs-center title font-weight-light">Sign up</h4>
                            <v-form >
                                <v-text-field
                                    v-model="signupUsername"
                                    outline
                                    :rules="[required]"
                                    prepend-icon="face"
                                    label="Username"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="signupEmail"
                                    outline
                                    :rules="[validEmail, required]"
                                    prepend-icon="alternate_email"
                                    label="Email"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="signupPassword"
                                    :rules="[min6, required]"
                                    outline
                                    prepend-icon="lock_open"
                                    label="Password"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    v-model="signupConfirm"
                                    :rules="[min6, required]"
                                    outline
                                    prepend-icon="lock_open"
                                    label="Confirm password"
                                    required
                                ></v-text-field>
                                <v-btn
                                    :disabled="!signupUsername || !signupEmail || !signupPassword || !signupConfirm || signupConfirm !== signupPassword"
                                    large
                                    color="primary"
                                    @click="submitSignup"
                                >Sign up</v-btn>
                                <h4 v-if="signupError.length > 0"
                                    class="my-4 text-xs-center title font-weight-light red--text"
                                >{{ signupError }}</h4>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import { SIGN_IN, SIGN_UP } from "../graphql"
import { onLogin } from "../vue-apollo"
import { validEmail, min6, required } from "../rules"

export default {
    apollo: {
        signin: {
            query: SIGN_IN,
            variables () {
                return {
                    email: this.email,
                    password: this.password
                }
            },
            update (data) {
                this.skipQuery = true
                this.error = data.signin.error
                onLogin(this.$apollo.provider.defaultClient, data.signin.token)
                this.$router.replace("/")
            },
            skip () {
                return this.skipQuery
            }
        },
        signup: {
            query: SIGN_UP,
            variables () {
                return {
                    username: this.signupUsername,
                    email: this.signupEmail,
                    password: this.signupPassword
                }
            },
            update (data) {
                this.skipQuery2 = true
                this.error = data.signup.error
                onLogin(this.$apollo.provider.defaultClient, data.signup.token)
                this.$router.replace("/")
            },
            skip () {
                return this.skipQuery2
            }
        }
    },
    methods: {
        submitSignin: function (e) {
            e.preventDefault()
            this.skipQuery = false
            this.$apollo.queries.signin.refetch()
        },
        submitSignup: function (e) {
            e.preventDefault()
            this.skipQuery2 = false
            this.$apollo.queries.signup.refetch()
        },
        validEmail,
        min6,
        required
    },
    data () {
        return {
            email: "",
            password: "",
            signupUsername: "",
            signupEmail: "",
            signupPassword: "",
            signupConfirm: "",
            error: "",
            signupError: "",
            showPassword: false,
            skipQuery: true,
            skipQuery2: true
        }
    }
}

</script>
